import { motion } from 'framer-motion';
import { Twitter, Linkedin, Globe } from 'lucide-react';

type TeamMemberProps = {
  name: string;
  role: string | React.ReactNode;
  image: string;
  bio: string;
  number?: number;
  social?: {
    twitter?: string;
    linkedin?: string;
    website?: string;
  };
  delay?: number;
};

const TeamMember = ({ name, role, image, bio, number, social = {}, delay = 0 }: TeamMemberProps) => {
  return (
    <motion.div
      className="bg-white rounded-lg shadow-md overflow-hidden border border-primary"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
    >
      <img src={image} alt={name} className="w-full h-64 object-cover" />
      <div className="p-6">
        <div className="flex items-center mb-1">
          {number !== undefined && (
            <span className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center text-sm font-semibold mr-2">
              #{number}
            </span>
          )}
          <div className="flex-grow">
            <h3 className="text-xl font-semibold">{name}</h3>
            <div className="text-primary">{role}</div>
          </div>
        </div>
        <p className="text-gray-600 mb-4">{bio}</p>
        
        {(social.twitter || social.linkedin || social.website) && (
          <div className="flex space-x-4">
            {social.twitter && (
              <a
                href={social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label={`${name}'s Twitter`}
              >
                <Twitter size={20} />
              </a>
            )}
            {social.linkedin && (
              <a
                href={social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label={`${name}'s LinkedIn`}
              >
                <Linkedin size={20} />
              </a>
            )}
            {social.website && (
              <a
                href={social.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label={`${name}'s Website`}
              >
                <Globe size={20} />
              </a>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default TeamMember;